import React, { useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import JImg1 from "../../assets/clients/Joomla-flat-logo-en.png";
import WImg2 from "../../assets/clients/wordpress.png";
import DImg3 from "../../assets/clients/druplicon-small.png";
import MImg4 from "../../assets/clients/Magento.png";
import PImg5 from "../../assets/clients/prestashop.png";
import TImg6 from "../../assets/clients/Typo3.jpg";
import TImg7 from "../../assets/clients/TextPattern.png";
import WImg8 from "../../assets/clients/Wix-Icon.png";
import SImg9 from "../../assets/clients/spotify.png";
import BImg10 from "../../assets/clients/blogger-logo.webp";
import BtImg11 from "../../assets/clients/b24.png";
import GImg12 from "../../assets/clients/ghostfam.webp";
import BCImg13 from "../../assets/clients/BCommerce.png";
import WImg14 from "../../assets/clients/woocommerce.png";
import HImg15 from "../../assets/clients/Hubspot.png";

// Static Cards Data
const cards = [
  { id: 1, image: JImg1, heading: "Joomla" },
  { id: 2, image: WImg2, heading: "WordPress" },
  { id: 3, image: DImg3, heading: "Drupal" },
  { id: 4, image: MImg4, heading: "Magento" },
  { id: 5, image: PImg5, heading: "Prestashop" },
  { id: 6, image: TImg6, heading: "TYPO3" },
  { id: 7, image: TImg7, heading: "Textpattern" },
  { id: 8, image: WImg8, heading: "WIX" },
  { id: 9, image: SImg9, heading: "Shopify" },
  { id: 10, image: BImg10, heading: "Blogger" },
  { id: 11, image: BtImg11, heading: "Bitrix24" },
  { id: 12, image: GImg12, heading: "Ghost" },
  { id: 13, image: BCImg13, heading: "BigCommerce" },
  { id: 14, image: WImg14, heading: "Woocommerce" },
  { id: 15, image: HImg15, heading: "HubSpot" },
];

const Partners = () => {
  const carouselRef = useRef(null);

  const scrollNext = () => {
    if (carouselRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = carouselRef.current;
      if (scrollLeft + clientWidth >= scrollWidth) {
        carouselRef.current.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        carouselRef.current.scrollBy({ left: clientWidth, behavior: "smooth" });
      }
    }
  };

  const scrollPrev = () => {
    if (carouselRef.current) {
      const { scrollLeft } = carouselRef.current;
      if (scrollLeft === 0) {
        carouselRef.current.scrollTo({
          left: carouselRef.current.scrollWidth,
          behavior: "smooth",
        });
      } else {
        carouselRef.current.scrollBy({
          left: -carouselRef.current.clientWidth,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (carouselRef.current) {
        carouselRef.current.style.overflowX =
          window.innerWidth <= 768 ? "hidden" : null;
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(scrollNext, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white shadow lg:h-[65vh] md:h-[40vh] h-auto flex flex-col justify-center items-center md:py-10 pt-10 md:pt-0 px-4 md:px-24">
      <div className="text-center">
        <h2 className="text-xs mb-0 text-gray-900 md:mb-10 md:text-lg font-medium max-w-3xl mx-auto">
          We build websites using CMS-based applications, offering static sites
          with fixed content or dynamic ones with full content management. Our
          expert team ensures the best quality, no matter the technology.
        </h2>
      </div>

      <div className="relative w-full flex items-center">
        <button
          onClick={scrollPrev}
          className="absolute hidden left-0 z-10 md:flex bg-main1 items-center justify-center h-12 w-12 bg-primary text-white rounded-full p-2 shadow-md transition-all"
        >
          <FontAwesomeIcon icon={faAngleLeft} className="text-lg" />
        </button>

        <div
          ref={carouselRef}
          className="flex md:gap-12 gap-5 overflow-hidden max-w-full lg:max-w-4xl md:max-w-3xl mx-auto justify-center items-center px-4"
        >
          {cards.map((card) => (
            <div
              key={card.id}
              className="flex-shrink-0 w-20 h-28 sm:w-28 sm:h-36 lg:w-40 lg:h-44 flex flex-col justify-center items-center gap-2"
            >
              <div className="w-full h-20 sm:h-24 lg:h-28 flex justify-center items-center">
                <img
                  src={card.image}
                  alt={card.heading}
                  className="w-full h-auto max-h-full object-contain"
                />
              </div>
              <span className="text-xs sm:text-sm font-medium text-gray-700 text-center">
                {card.heading}
              </span>
            </div>
          ))}
        </div>

        <button
          onClick={scrollNext}
          className="absolute hidden right-0 z-10 md:flex items-center justify-center h-12 w-12 bg-main1 rounded-full p-2 text-white shadow-md transition-all"
        >
          <FontAwesomeIcon icon={faAngleRight} className="text-lg" />
        </button>
      </div>
    </div>
  );
};

export default Partners;
